window.app.animations = (function($) {

	var CLASSNAME = 'ui-animate';

	var isEnabled = false;


	/**
	 * ...
	 */
	function enable() {

		if (!isEnabled) {
			$(document.body).addClass(CLASSNAME);
			isEnabled = true;
		}

	}


	/**
	 * ...
	 */
	function disable() {

		if (isEnabled) {
			$(document.body).removeClass(CLASSNAME);
			isEnabled = false;
		}

	}


	// Return public API
	return {
		enable:     enable,
		disable:    disable,
	};

})($);
